export default __webpack_public_path__ + "static/media/party-taylor.a332045f.jpg";